// NPM Imports
import React, { Fragment, Component } from "react";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "@revvsales/components";

// Internal Imports
import { GlobalUtils } from "../../../utils";
import { COMMON, GOOGLE_SHEET_VIEW_CONTROL } from "../../../constants";
// import GoogleSheetTableComponent from "../../GoogleSheetTable/GoogleSheetTableComponent";
import Table from "../../RevvTable";

// Actions Imports
import { updateDocumentClickedComponentID } from "../../../actions/DocumentActions";
import { QuotationActions, GoogleSheetActions } from "../../../actions";

// Service Imports && Methods
import {
  authGoogleSheetService,
  fetchGoogleUserInfo,
} from "../../../actions/GoogleSheetActions/googleSheetServices";
import { googleSheetViewControl } from "../../../actions/GoogleSheetActions/methods";

// Destructuring
const { toggleTabAndToolPanelData, handleGSheetAuth } = QuotationActions;
const { checkGSheetStoreForData } = GoogleSheetActions;
const { TABLE_TYPE } = COMMON;
const { writeDataToLocalStorage, readDataFromLocalStorage } = GlobalUtils;

class GoogleSheetContainer extends Component {
  gsheetContainerRef = React.createRef();

  state = {};

  componentDidMount() {
    if (!this.props.isGoogleSheetAuthenticated) {
      fetchGoogleUserInfo()
        .then(() => {
          this.props.handleGSheetAuth(true);
        })
        .catch(error => {
          console.error("error", error);
        });
    }
    if (
      this.props.isComponentActive &&
      this.gsheetContainerRef &&
      this.gsheetContainerRef.current
    ) {
      this.gsheetContainerRef.current.focus();
    }
  }

  _moveToLinkedGoogleSheet = section => {
    checkGSheetStoreForData(section.id);
    if (this.props.isLocked) {
      this.props.toggleTabAndToolPanelData({
        tabView: section.label,
        isOpen: false,
        panelView: "",
        page: TABLE_TYPE.GOOGLE_SHEET,
        tabViewType: TABLE_TYPE.GOOGLE_SHEET,
        googleSheetId: section.id,
      });
    } else {
      this.props.toggleTabAndToolPanelData({
        tabView: section.label,
        isOpen: true,
        panelView: "google-catalog",
        page: TABLE_TYPE.GOOGLE_SHEET,
        tabViewType: TABLE_TYPE.GOOGLE_SHEET,
        googleSheetId: section.id,
      });
    }
  };

  _authGoogleSheet = section => {
    // this refers ==> when google sheet auth success then move to particular tab
    const clickedTabItem = {
      name: section.label,
      alias: section.label,
      type: section.type,
      id: section.id,
    };
    authGoogleSheetService()
      .then(res => {
        writeDataToLocalStorage("lastDocPath", window.location.pathname);
        writeDataToLocalStorage("clickedTabItem", clickedTabItem);
        window.location.replace(res.AuthCodeURL);
      })
      .catch(error => {
        console.error(`SignUp => authEmailVerificationService => ${error}`);
      });
  };

  _checkForGSheetData = section => {
    // isArray check to handle case when data format was section.data was []
    if (section.data && Array.isArray(section.data)) {
      if (section.data.length > 0) {
        return true;
      }
    } else if (
      "data" in section &&
      "data" in section.data &&
      section.data.data.length > 0
    ) {
      return true;
    }
    return false;
  };

  _checkUserIsAuthenticatedOrNot = section => {
    if (this.props.isGoogleSheetAuthenticated) {
      this._moveToLinkedGoogleSheet(section);
    } else {
      this._authGoogleSheet(section);
    }
  };

  _getTopLabel = CURRENT_USER => {
    let buttonLabel = "";
    const { docOwnerID, isGoogleSheetAuthenticated, section } = this.props;
    if (!section) return buttonLabel;
    const gSheetCount = this._pickLastWordFromLabel(section.label);
    if (
      googleSheetViewControl(CURRENT_USER, docOwnerID) ===
        GOOGLE_SHEET_VIEW_CONTROL.DOC_OWNER ||
      googleSheetViewControl(CURRENT_USER, docOwnerID) ===
        GOOGLE_SHEET_VIEW_CONTROL.ACCOUNT_OWNER
    ) {
      if (isGoogleSheetAuthenticated && this._checkForGSheetData(section)) {
        buttonLabel = `Go To ${section.label}`;
      } else if (!isGoogleSheetAuthenticated) {
        buttonLabel = `Connect to Google Sheet ${gSheetCount}`;
      } else {
        buttonLabel = `Select Google Sheet ${gSheetCount}`;
      }
    } else if (
      googleSheetViewControl(CURRENT_USER, docOwnerID) ===
      GOOGLE_SHEET_VIEW_CONTROL.EXTERNAL_USER
    ) {
      buttonLabel = "";
    }
    return buttonLabel;
  };

  _pickLastWordFromLabel = label => {
    const n = label.split(" ");
    return n[n.length - 1];
  };

  _getHoverLabel = CURRENT_USER => {
    let buttonLabel = "";
    const { docOwnerID, isGoogleSheetAuthenticated, section } = this.props;
    if (
      googleSheetViewControl(CURRENT_USER, docOwnerID) ===
        GOOGLE_SHEET_VIEW_CONTROL.DOC_OWNER ||
      googleSheetViewControl(CURRENT_USER, docOwnerID) ===
        GOOGLE_SHEET_VIEW_CONTROL.ACCOUNT_OWNER
    ) {
      if (isGoogleSheetAuthenticated && this._checkForGSheetData(section)) {
        buttonLabel = "Select Google Sheet";
      } else if (
        isGoogleSheetAuthenticated &&
        this._checkForGSheetData(section)
      ) {
        buttonLabel = `Go To ${section.label}`;
      } else {
        buttonLabel = "Connect to Google Sheet";
      }
    } else if (
      googleSheetViewControl(CURRENT_USER, docOwnerID) ===
      GOOGLE_SHEET_VIEW_CONTROL.EXTERNAL_USER
    ) {
      buttonLabel = "";
    }
    return buttonLabel;
  };

  _handleOnClick = event => {
    event.preventDefault();
    const { isComponentActive, isLocked, section } = this.props;
    if (!isLocked && !isComponentActive) {
      this.props.updateDocumentClickedComponentID(
        section.id,
        true,
        section.type,
      );
      this.props.createDocSectionRef(React.createRef());
    }
  };

  _handleOnBlur = event => {
    event.preventDefault();
    if (
      this.props.isComponentActive &&
      this.props.preventClickedComponentIdUpdate
    ) {
      this.props.updateDocumentClickedComponentID(null, true, null);
    }
  };

  render() {
    const CURRENT_USER = readDataFromLocalStorage("revvsalesUser");
    const {
      sectionID,
      section,
      isLocked,
      hiddenCols,
      handleBlur,
      hoveredActiveComponentId,
    } = this.props;
    return (
      <Fragment>
        <div
          ref={this.gsheetContainerRef}
          id={sectionID}
          className="google-sheet-container"
          onClick={this._handleOnClick}
          onKeyPress={() => {}}
          onBlur={this._handleOnBlur}
          role="button"
          tabIndex={0}>
          {this._getTopLabel(CURRENT_USER) !== "" && (
            <Button
              className="google-sheet-label"
              data-test="googlesheetcontainer-link-btn"
              onClick={() => this._checkUserIsAuthenticatedOrNot(section)}>
              <i
                data-test="google-sheet-ic--link"
                className="google-sheet-ic-link">
                <FontAwesomeIcon icon={["far", "link"]} />
              </i>
              {this._getTopLabel(CURRENT_USER)}
            </Button>
          )}

          {!isLocked && (
            <Button
              className="google-sheet-edit-btn"
              data-test="googlesheetcontainer-edit-btn"
              onClick={() => this._checkUserIsAuthenticatedOrNot(section)}>
              {this._getHoverLabel(CURRENT_USER)}
            </Button>
          )}

          {section && this._checkForGSheetData(section) ? (
            <Fragment>
              {
                // <GoogleSheetTableComponent
                // section={section}
                // hiddenCols={hiddenCols}
                // />
              }
              <Table
                className="gsheet-table"
                type="gSheet"
                section={section}
                hiddenCols={hiddenCols}
                handleBlur={handleBlur}
                hoveredActiveComponentId={hoveredActiveComponentId}
                sectionID={sectionID}
              />
            </Fragment>
          ) : (
            <table className="gsheet-table">
              <thead>
                <tr>
                  <th>Column1</th>
                  <th>Column2</th>
                  <th>Column3</th>
                  <th>Column4</th>
                  <th>Column5</th>
                </tr>
              </thead>
              <tbody>
                <tr className="google-sheet-container-blank-tr">
                  <td />
                  <td />
                  <td />
                  <td />
                  <td />
                </tr>
              </tbody>
            </table>
          )}
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state, props) => {
  const { sectionID, section } = props;
  // let sectionList = [];
  const {
    // content: { sections },
    isGoogleSheetAuthenticated,
    document: {
      id: docID,
      isLocked,
      created_by: { id: docOwnerID },
      status: docStatus,
      stage: docStage,
      scope,
    } = {},
    clickedActiveComponentId,
    preventClickedComponentIdUpdate,
  } = state.DocumentStore;

  const { isOpen, view } = state.ToolPaneStore;
  // sectionList = sections;
  // const section = sectionList.find(item => item.id === sectionID);
  let isComponentActive = false;
  if (clickedActiveComponentId === sectionID) isComponentActive = true;
  return {
    section,
    isOpen,
    view,
    isGoogleSheetAuthenticated,
    docID,
    isLocked,
    docOwnerID,
    docStatus,
    docStage,
    scope,
    isComponentActive,
    preventClickedComponentIdUpdate,
  };
};

const mapDispatchToProps = {
  toggleTabAndToolPanelData,
  updateDocumentClickedComponentID,
  handleGSheetAuth,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(GoogleSheetContainer);



// WEBPACK FOOTER //
// ./src/components/DocumentItems/GoogleSheetContainer/GoogleSheetContainer.js